/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_data_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A bit is a single binary digit (0 or 1); a byte is a group of 8 bits. Network and internet speeds are usually quoted in bits per second (Mbps), while file sizes are quoted in bytes (MB) — that's why a '100 Mbps' connection downloads at about 12.5 MB/s, not 100 MB/s.`)
};

const es_uc_data_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un bit es un dígito binario único (0 o 1); un byte es un grupo de 8 bits. Las velocidades de red e internet se citan generalmente en bits por segundo (Mbps), mientras que los tamaños de archivo se citan en bytes (MB) — por eso una conexión '100 Mbps' descarga aproximadamente 12.5 MB/s, no 100 MB/s.`)
};

const de_uc_data_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Bit ist eine einzelne Binärziffer (0 oder 1); ein Byte ist eine Gruppe von 8 Bit. Netzwerk- und Internetgeschwindigkeiten werden meist in Bit pro Sekunde (Mbps) angegeben, während Dateigrößen in Byte (MB) angegeben werden — deshalb lädt eine '100-Mbps'-Verbindung mit etwa 12.5 MB/s herunter, nicht mit 100 MB/s.`)
};

const nl_uc_data_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een bit is een enkel binair cijfer (0 of 1); een byte is een groep van 8 bits. Netwerk- en internetsnelheden worden meestal aangehaald in bits per seconde (Mbps), terwijl bestandsgroottes in bytes (MB) worden aangehaald — dat is waarom een '100 Mbps' verbinding ongeveer 12.5 MB/s downloadt, niet 100 MB/s.`)
};

const fr_uc_data_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un bit est un seul chiffre binaire (0 ou 1) ; un octet est un groupe de 8 bits. Les vitesses de réseau et Internet sont généralement citées en bits par seconde (Mbps), tandis que les tailles de fichiers sont citées en octets (MB) — c'est pourquoi une connexion '100 Mbps' télécharge à environ 12,5 MB/s, pas 100 MB/s.`)
};

const it_uc_data_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un bit è una singola cifra binaria (0 o 1); un byte è un gruppo di 8 bit. Le velocità di rete e internet sono solitamente citate in bit al secondo (Mbps), mentre le dimensioni dei file sono citate in byte (MB) — ecco perché una connessione '100 Mbps' scarica a circa 12,5 MB/s, non 100 MB/s.`)
};

const pt_br2_uc_data_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um bit é um único dígito binário (0 ou 1); um byte é um grupo de 8 bits. Velocidades de rede e internet são geralmente citadas em bits por segundo (Mbps), enquanto tamanhos de arquivo são citados em bytes (MB) — é por isso que uma conexão de '100 Mbps' baixa em cerca de 12.5 MB/s, não 100 MB/s.`)
};

const pt_uc_data_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um bit é um único dígito binário (0 ou 1); um byte é um grupo de 8 bits. As velocidades de rede e internet são geralmente citadas em bits por segundo (Mbps), enquanto os tamanhos de ficheiro são citados em bytes (MB) — é por isto que uma ligação de '100 Mbps' transfere cerca de 12,5 MB/s, não 100 MB/s.`)
};

const ja_uc_data_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビットは単一のバイナリ数字(0または1)です。バイトは8ビットのグループです。ネットワークとインターネット速度は通常、ビット毎秒(Mbps)でクォートされます。ファイルサイズはバイト(MB)でクォートされています — 「100 Mbps」接続が約12.5 MB/s でダウンロードされる理由は、100 MB/s ではなく。`)
};

const zh_uc_data_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_data_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_data_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_data_faq2_a", locale)
	if (locale === "en") return en_uc_data_faq2_a(inputs)
	if (locale === "es") return es_uc_data_faq2_a(inputs)
	if (locale === "de") return de_uc_data_faq2_a(inputs)
	if (locale === "nl") return nl_uc_data_faq2_a(inputs)
	if (locale === "fr") return fr_uc_data_faq2_a(inputs)
	if (locale === "it") return it_uc_data_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_uc_data_faq2_a(inputs)
	if (locale === "pt") return pt_uc_data_faq2_a(inputs)
	if (locale === "ja") return ja_uc_data_faq2_a(inputs)
	return zh_uc_data_faq2_a(inputs)
};